module.exports = __webpack_public_path__ + "media/images/twitter_48-8178564448658fe33e94ea6c000dc0c2.png";